import { useMemo } from "react";
import { values } from "ramda";

const useMemoObject = <T extends object>(object: T) => {
  return useMemo(() => object, values(object));
};

export default useMemoObject;
